import React from "react";
import ImageLightbox from "./imageLightbox";

// Renders markdown images (![alt](src)) with consistent spacing and
// treats the alt text as a visible caption underneath, since plain
// markdown has no native caption syntax. Clicking the image opens
// a larger view in a modal.
const MdxImage = ({ alt, ...rest }) => (
  <span className="block my-10">
    <ImageLightbox src={rest.src} alt={alt}>
      <img
        {...rest}
        alt={alt || ""}
        className="w-full h-auto"
        loading="lazy"
      />
    </ImageLightbox>
    {alt && (
      <span className="block text-center text-[13px] text-[#888888] font-light mt-3">
        {alt}
      </span>
    )}
  </span>
);

// Opens external links in a new tab automatically; internal links
// (starting with "/") behave normally. Styling matches the red
// accent already used for links elsewhere on the site.
const MdxLink = ({ href = "", children, ...rest }) => {
  const isExternal = /^https?:\/\//.test(href);
  return (
    <a
      href={href}
      className="text-[#de2110] underline"
      {...(isExternal ? { target: "_blank", rel: "noreferrer" } : {})}
      {...rest}
    >
      {children}
    </a>
  );
};

const mdxComponents = {
  img: MdxImage,
  a: MdxLink,
};

export default mdxComponents;
